
import Vue from "vue";
import Chapter from "./Chapter.vue";

interface ChaptersListProps {
  message: string;
}

export default Vue.extend<{}, {}, {}, ChaptersListProps>({
  name: "ChaptersList",
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    message: String,
  },
  methods: {
    toggleShowChapters() {
      this.$data.isOpen = !this.$data.isOpen;
    },
  },
  computed: {
    title() {
      return this.$store.getters.title;
    },
    titleUri() {
      return this.$store.getters.titleUri;
    },
    hideTopLevel() {
      return this.$store.getters.hideTopLevel;
    },
    hasThirdLevel() {
      return this.$store.getters.hasThirdLevel;
    },
    chaptersArray() {
      return this.$store.getters.chaptersArray;
    },
  },
  components: {
    Chapter,
  },
});
